import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { CheckCircle2, ChevronRight, Star, Award } from "lucide-react"
import { Button } from "../ui/button"

const VISIBLE_FEATURES = 3

export default function Healthcheckupspackageswidget() {
  const [packages, setPackages] = useState([])
  const [loading, setLoading] = useState(true)
  const [locationId, setLocationId] = useState("")

  useEffect(() => {
    fetch("/apis/web/clinics")
      .then(res => res.json())
      .then(data => {
        if (data.result && data.result.length > 0) {
          const firstId = data.result[0].Hospital_Id
          setLocationId(firstId)
        }
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (!locationId) return
    setLoading(true)
    fetch(`/apis/web/healthpackage?hospitalId=${locationId}`)
      .then(res => res.json())
      .then(res => {
        if (res?.success && Array.isArray(res.data)) {
          setPackages(res.data.slice(0, 3))
        }
      })
      .catch(err => console.error("Error fetching packages:", err))
      .finally(() => setLoading(false))
  }, [locationId])

  if (loading || packages.length === 0) return null

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col items-center mb-10 text-center">
          <h2 className="mb-4 text-3xl font-bold md:text-4xl">Comprehensive Health Check-Up Packages</h2>
          <p className="max-w-2xl text-gray-500">
            Choose from our range of health packages designed to give you a complete picture of your health.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {packages.map((pkg, index) => {
            const features = Array.isArray(pkg.services) ? pkg.services.map(s => s.servName) : []
            const badge = index === 0 ? "Popular" : index === 1 ? "Recommended" : ""
            const badgeBg = badge === "Popular" ? "bg-pink-600" : "bg-[#0B6056]"
            const BadgeIcon = badge === "Popular" ? Star : Award

            return (
              <div key={pkg.servCode} className="bg-white rounded-2xl border border-gray-200 flex flex-col h-full hover:shadow-lg transition-shadow duration-300">
                <div className="px-5 pt-5 pb-5 flex flex-col flex-1">
                  {badge && (
                    <div className="mb-3">
                      <span className={`${badgeBg} text-white text-xs font-semibold px-3 py-1.5 rounded-full inline-flex items-center gap-1.5`}>
                        <BadgeIcon className="w-3.5 h-3.5" />
                        {badge}
                      </span>
                    </div>
                  )}

                  <h3 className="text-lg font-bold text-gray-900 mb-1">{pkg.servName}</h3>
                  <p className="text-sm text-gray-500 mb-1">{pkg.hospitalName}</p>
                  <p className="text-2xl font-bold text-primary mb-4">₹{pkg.serviceCost}/-</p>

                  <div className="space-y-2.5 mb-2">
                    {features.slice(0, VISIBLE_FEATURES).map((feature, i) => (
                      <div key={i} className="flex items-center gap-2.5 text-sm text-gray-700">
                        <CheckCircle2 className="w-4.5 h-4.5 text-green-500 flex-shrink-0" />
                        {feature.trim()}
                      </div>
                    ))}
                  </div>
                  {features.length > VISIBLE_FEATURES && (
                    <p className="text-xs text-[#545769] mb-4">+{features.length - VISIBLE_FEATURES} more inclusions</p>
                  )}

                  <div className="mt-auto pt-3">
                    <Button className="w-full gap-2" asChild>
                      <Link to={`/packages/${pkg.servCode}?location=${locationId}`}>
                        View Package Details
                        <ChevronRight className="w-4 h-4" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <div className="flex justify-center mt-8">
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
            asChild
          >
            <Link to="/packages">
              View All Packages
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
